// src/components/LandingPage/Hero/HeroMobile.tsx
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../../assets/world_ciber.png';

export default function HeroMobile() {
  const { t } = useTranslation();

  const styles = `
    @keyframes slideInLeft {
      from {
        opacity: 0;
        transform: translateX(-50px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    @keyframes slideInRight {
      from {
        opacity: 0;
        transform: translateX(50px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    .slide-in-left {
      opacity: 0;
      transform: translateX(-50px);
      animation: slideInLeft 1.5s ease-out forwards;
    }

    .slide-in-right {
      opacity: 0;
      transform: translateX(50px);
      animation: slideInRight 1.5s ease-out forwards;
      animation-delay: 0.3s;
    }

    /* Capa de estrellas */
    .stars {
      position: absolute;
      inset: 0;
      background: #000; /* color base negro */
      z-index: 0;
      background-image:
        radial-gradient(2px 2px at 10% 20%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 20% 80%, #fff, transparent),
        radial-gradient(1px 1px at 30% 30%, #fff, transparent),
        radial-gradient(2px 2px at 40% 90%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 50% 50%, #fff, transparent),
        radial-gradient(1px 1px at 60% 70%, #fff, transparent),
        radial-gradient(2px 2px at 70% 40%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 80% 60%, #fff, transparent),
        radial-gradient(1px 1px at 90% 10%, #fff, transparent),
        radial-gradient(2px 2px at 15% 50%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 85% 20%, #fff, transparent),
        radial-gradient(1px 1px at 25% 60%, #fff, transparent),
        radial-gradient(2px 2px at 5% 10%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 95% 80%, #fff, transparent),
        radial-gradient(1px 1px at 50% 90%, #fff, transparent),
        radial-gradient(2px 2px at 75% 25%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 35% 65%, #fff, transparent),
        radial-gradient(1px 1px at 65% 35%, #fff, transparent),
        radial-gradient(2px 2px at 85% 15%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 95% 95%, #fff, transparent),
        radial-gradient(1px 1px at 5% 95%, #fff, transparent),
        radial-gradient(2px 2px at 15% 15%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 25% 25%, #fff, transparent),
        radial-gradient(1px 1px at 35% 35%, #fff, transparent),
        radial-gradient(2px 2px at 45% 45%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 55% 55%, #fff, transparent),
        radial-gradient(1px 1px at 65% 65%, #fff, transparent),
        radial-gradient(2px 2px at 75% 75%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 85% 85%, #fff, transparent),
        radial-gradient(1px 1px at 95% 5%, #fff, transparent);
      background-size: cover;
      background-repeat: repeat;
    }
  `;

  return (
    <section
      className="relative min-h-screen overflow-visible"
      style={{
        // Empuja el Hero justo debajo del banner+navbar y safe-area superior:
        paddingTop: 'env(safe-area-inset-top)'
      }}
    >
      {/* Inyectamos keyframes y fondo estrellado */}
      <style>{styles}</style>

      {/* Capa de estrellas */}
      <div className="stars" />

      {/* Overlay oscuro */}
      <div className="absolute inset-0 bg-black/30 z-10" />

      {/* Contenido principal */}
      <div className="relative z-20 flex flex-col items-center justify-center h-full w-full px-6">
        {/* Badge animado */}
        <div
          className="mt-6 inline-block mb-4 px-4 py-1.5 bg-primary/30 rounded-full
                     text-primary/200 text-sm font-medium animate-pulse slide-in-left"
        >
          {t('home.hero_discover')}
        </div>

        {/* Logo animado */}
        <div className="slide-in-left mb-4">
          <img
            src={logo}
            alt="Damelio Logo"
            className="w-60 h-60 object-contain animate-pulse drop-shadow-lg"
          />
        </div>

        {/* Título y subtítulo centrados */}
        <h1 className="text-3xl font-bold text-white mb-2 slide-in-left text-center">
          {t('home.hero_title')}
        </h1>
        <h2 className="text-3xl font-bold text-white mb-6 slide-in-left text-center">
          {t('home.hero_subtitle')}
        </h2>

        {/* Descripción */}
        <p className="text-base text-gray-300 mb-8 max-w-sm text-center slide-in-left">
          {t('home.hero_description')}
        </p>

        {/* Único botón */}
        <div className="slide-in-right">
          <Link
            to="/documentation"
            className="bg-primary text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2"
          >
            {t('home.hero_view_docs')}
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
